import { render, staticRenderFns } from "./ConfirmSendToProduction.vue?vue&type=template&id=8d44ceb2&scoped=true"
import script from "./ConfirmSendToProduction.vue?vue&type=script&lang=ts"
export * from "./ConfirmSendToProduction.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmSendToProduction.vue?vue&type=style&index=0&id=8d44ceb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d44ceb2",
  null
  
)

export default component.exports